import { MixtureListProgressState } from "../entities/Mixture";

export const getMixtureLineProgressColor = (
  currentProgress: number,
): MixtureListProgressState => {
  if (currentProgress < 100) {
    return MixtureListProgressState.NOT_COMPLETED;
  }

  if (currentProgress > 100) {
    return MixtureListProgressState.OVER_COMPLETED;
  }

  return MixtureListProgressState.COMPLETED;
};
